module.exports = __webpack_public_path__ + "static/media/moveUpArrow.b89fcde3.svg";